var map = {
	"./Corruption-Risk-Prevention-Plan.pdf": 7966,
	"./ISO_27001.pdf": 8260,
	"./ISO_9001.pdf": 2549,
	"./NP_4457.pdf": 4737,
	"./PARC-brochura-tecnica-FEIRA-EN.pdf": 8843,
	"./PARC-details-techniques-fr.pdf": 3023,
	"./PARC-detalhes-tecnicos-pt.pdf": 6490,
	"./PARC-technical-details-en.pdf": 3186,
	"./Plano-de-Prevencao-de-Riscos-de-Corrupcao.pdf": 987,
	"./Relatorio-Execucao-Anual-PPR-2024.pdf": 6894,
	"./Relatorio-Execucao-Anual-PPR-2025.pdf": 3645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4824;